import React from 'react';
import { Spin } from '@douyinfe/semi-ui';
import { renderTimestamp } from '../../helpers/render';

const StatusCards = ({ data, loading }) => {
    const { balance, usage, accessdate, tokenValid } = data;

    if (!tokenValid && !loading) return null;

    const cards = [
        {
            label: '令牌总额',
            value: balance === 100000000 ? '无限' : (balance !== undefined ? `$${balance.toFixed(3)}` : '未知'),
            color: 'var(--apple-blue)',
            icon: 'B',
            bgGradient: 'linear-gradient(135deg, rgba(0, 113, 227, 0.1) 0%, rgba(0, 113, 227, 0) 100%)'
        },
        {
            label: '剩余额度',
            value: balance === 100000000 ? '无限制' : (balance !== undefined && usage !== undefined ? `$${(balance - usage).toFixed(3)}` : '未知'),
            color: 'var(--apple-green)',
            icon: 'R',
            bgGradient: 'linear-gradient(135deg, rgba(52, 199, 89, 0.1) 0%, rgba(52, 199, 89, 0) 100%)'
        },
        {
            label: '已用额度',
            value: usage !== undefined ? `$${usage.toFixed(3)}` : '未知',
            color: 'var(--apple-orange)',
            icon: 'U',
            bgGradient: 'linear-gradient(135deg, rgba(255, 149, 0, 0.1) 0%, rgba(255, 149, 0, 0) 100%)'
        },
        {
            label: '有效期至',
            value: accessdate === 0 ? '永不过期' : (accessdate ? renderTimestamp(accessdate) : '未知'),
            color: 'var(--apple-purple)',
            icon: 'D',
            bgGradient: 'linear-gradient(135deg, rgba(175, 82, 222, 0.1) 0%, rgba(175, 82, 222, 0) 100%)'
        }
    ];

    return (
        <Spin spinning={loading}>
            <div className="stats-grid">
                {cards.map((card, index) => (
                    <div
                        key={index}
                        className="stat-card"
                        style={{
                            background: `linear-gradient(to bottom right, var(--apple-card-bg), rgba(255,255,255,0.5)), ${card.bgGradient}`
                        }}
                    >
                        <div className="stat-label">{card.label}</div>
                        <div className="stat-value" style={{ color: card.color }}>
                            {card.value}
                        </div>
                        <div className="stat-icon-bg" style={{
                            fontSize: '140px',
                            color: card.color,
                            fontWeight: 900,
                            lineHeight: 0.8,
                            opacity: 0.08
                        }}>
                            {card.icon}
                        </div>
                    </div>
                ))}
            </div>
        </Spin>
    );
};

export default StatusCards;

